import type { AxiosInstance } from 'axios'
import redaxios from 'redaxios'

/**
 *
 */
export const setupRedaxiosClient = (
  apiHost: string,
  headers?: Record<string, string>,
): AxiosInstance => {
  const instance = redaxios.create({
    baseURL: apiHost,
    headers: {
      ...headers,
    },
  }) as unknown as AxiosInstance

  return instance
}
